import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import cn from 'classnames';

var BtnLeftSmall = function BtnLeftSmall(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M.137 4.172L4.172.137a.488.488 0 0 1 .689.69L1.156 4.53l3.705 3.705a.488.488 0 0 1-.69.69L.138 4.89A.477.477 0 0 1 0 4.53a.474.474 0 0 1 .136-.357z"
  }));
};

BtnLeftSmall.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 4.9977479 9.0618038"
};

var BtnRightSmall = function BtnRightSmall(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4.997 4.529a.477.477 0 0 1-.136.361L.826 8.925a.489.489 0 0 1-.69-.69l3.706-3.704L.137.826a.489.489 0 0 1 .69-.69L4.86 4.173a.474.474 0 0 1 .136.357z"
  }));
};

BtnRightSmall.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 4.9977479 9.0618038"
};
import Button from "../Button";
import Icon from "../Icon";
import createStyles from "../createStyles";
var useStyles = createStyles(function (theme) {
  return {
    button: {
      position: 'absolute',
      top: '20px',
      width: 40,
      height: 40,
      border: "solid 1px ".concat(theme.palette.border),
      borderRadius: 0
    },
    nextButton: {
      right: '22px'
    },
    prevButton: {
      left: '22px'
    }
  };
});

var NavButton = function NavButton(_ref) {
  var direction = _ref.direction;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Button, {
    type: "button",
    className: cn(classes.button, _defineProperty({}, classes.prevButton, direction === 'Left'), _defineProperty({}, classes.nextButton, direction === 'Right')),
    "data-qa": "nav-button"
  }, /*#__PURE__*/React.createElement(Icon, {
    height: 11,
    width: 6,
    svg: direction === 'Right' ? BtnRightSmall : BtnLeftSmall
  }));
};

export default NavButton;